import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { PermissionToggleInfo } from "~/components/SharePrivateContentModal/shared/PermissionToggleInfo";
import { SharePrivateContentPermissionToggle } from "~/components/SharePrivateContentModal/shared/SharePrivateContentPermissionToggle";
export const EnableShareLinkDownloadToggle = /*#__PURE__*/ memo((param)=>{
    let { onToggle, checked, isLoading, infoText, disabled } = param;
    return /*#__PURE__*/ _jsx(SharePrivateContentPermissionToggle, {
        id: "canViewOriginal",
        label: "Allow downloads",
        checked: checked,
        isLoading: isLoading,
        onCheckedChange: onToggle,
        disabled: disabled,
        children: /*#__PURE__*/ _jsx(PermissionToggleInfo, {
            text: infoText
        })
    });
});
EnableShareLinkDownloadToggle.displayName = "EnableShareLinkDownloadToggle";
